import React, { Fragment } from 'react';

import Landing from 'Components/Landing/Landing';

const Layout = () => (
  <Fragment>
    <Landing />
  </Fragment>
);

export default Layout;
